import { memo } from "react";
import { DashedLineIcon, DottedLineIcon, SolidLineIcon } from "@/icons/widget-menu";
import { HStack, VStack } from "@/shared/ui/Stack";
import type { widgetOption } from "@/widgetMenu/widgetMenu";
import { BORDER_COLORS } from "../../constants/borderColors";
import type { BorderDashType, BorderOption } from "../../types";
import { BorderColorButton } from "./BorderColorButton";
import styles from "./BorderMenu.module.css";
import { BorderTypeButton } from "./BorderTypeButton";
import { BorderWidthInput } from "./BorderWidthInput";

interface BorderMenuContentProps {
    options: widgetOption<BorderOption>[];
    selectedBorderType: BorderDashType;
    selectedColor: string;
    onBorderTypeButtonClick: (borderType: BorderDashType) => void;
    onBorderColorButtonClick: (color: string) => void;
}

export const BorderMenuContent = memo(function BorderMenuContent({
    options,
    selectedBorderType,
    selectedColor,
    onBorderTypeButtonClick,
    onBorderColorButtonClick,
}: BorderMenuContentProps) {
    return (
        <VStack gap={20}>
            <HStack fullWidth gap={4}>
                <BorderTypeButton
                    borderType="solid"
                    selectedBorderType={selectedBorderType}
                    onClick={onBorderTypeButtonClick}
                    Icon={SolidLineIcon}
                />

                <BorderTypeButton
                    borderType="dashed"
                    selectedBorderType={selectedBorderType}
                    onClick={onBorderTypeButtonClick}
                    Icon={DashedLineIcon}
                />

                <BorderTypeButton
                    borderType="dotted"
                    selectedBorderType={selectedBorderType}
                    onClick={onBorderTypeButtonClick}
                    Icon={DottedLineIcon}
                />
            </HStack>

            <BorderWidthInput initialWidth={options[0].value.borderWidth} options={options} />

            <HStack className={styles.colorsWrapper} wrap="wrap" gap={4}>
                {BORDER_COLORS.map((color, index) => {
                    const isTransparent = index === 0;
                    const isWhite = index === BORDER_COLORS.length - 1;

                    return (
                        <BorderColorButton
                            key={color}
                            color={color}
                            selectedColor={selectedColor}
                            isTransparent={isTransparent}
                            isWhite={isWhite}
                            onClick={onBorderColorButtonClick}
                        />
                    );
                })}
            </HStack>
        </VStack>
    );
});
